import { useStyles } from './useStyles';
import { useHooks } from './useHooks';
import BasePageLayoutWrapper from '../../components/parts/common/BasePageLayoutWrapper';
import { CalendarGanttView } from '../../components/parts/calendar/CalendarGanttView';
import { FormProvider, useForm, UseFormReturn } from 'react-hook-form';
import { SiteProcessSelectfield } from '../../components/parts/input/ProcessSelectfield';
import { Button, Grid } from '@material-ui/core';
import { CalenderUrlModal } from '../../components/parts/calendar/CalenderUrlModal';
import { CustomTooltip } from '../../components/tooltip/CustomTooltip';
import { tooltipContents } from '../../components/tooltip/Const';

export type TSearchForm = {
  charge_user_id: { value: number; label: string };
};

export const CalendarPage: React.FC = () => {
  const classes = useStyles();
  // hook-formの初期設定
  const methods: UseFormReturn<TSearchForm> = useForm({
    defaultValues: { charge_user_id: { value: 0, label: '--' } }
  });
  const { setValue, getValues, reset } = methods;

  const {
    employeeList,
    inactiveEmployeeList,
    employeeId,
    handleOnChangeEmployeeId,
    isOpenPublishUrlModal,
    setIsOpenPublishUrlModal,
    handleClickPublishUrlButton
  } = useHooks({ setValue, getValues, reset });

  return (
    <BasePageLayoutWrapper patternName='calendar'>
      <div className={classes.containerPadding}>
        <Grid
          container
          spacing={1}
          className={classes.gridContainerBackgroundColor}
        >
          {/* 担当者選択 */}
          <FormProvider {...methods}>
            <Grid item sm={4} xs={8}>
              <SiteProcessSelectfield
                name='charge_user_id'
                listDatas={employeeList}
                value={getValues('charge_user_id')}
                onChange={handleOnChangeEmployeeId}
                errorMessage={
                  employeeId === 0 ? 'まず担当者を選択してください' : ''
                }
                required={false}
                error={false}
                inactiveListDatas={inactiveEmployeeList}
              />
            </Grid>
            {employeeId > 0 && (
              <Grid item sm={2} xs={4}>
                <CustomTooltip
                  title={tooltipContents.CalenderUrl}
                  placement='bottom-end'
                  interactive
                >
                  <div className={classes.publishUrlButtonWrapper}>
                    <Button
                      className={classes.publishUrlButton}
                      onClick={handleClickPublishUrlButton}
                    >
                      URL発行
                    </Button>
                  </div>
                </CustomTooltip>
              </Grid>
            )}
          </FormProvider>
        </Grid>
      </div>
      {/* ガントチャート＋日付指定 */}
      {employeeId > 0 && (
        <div className={classes.chartContainer}>
          <CalendarGanttView userId={employeeId} />
        </div>
      )}

      {/* URL発行モーダル */}
      <CalenderUrlModal
        isOpen={isOpenPublishUrlModal}
        setIsOpen={setIsOpenPublishUrlModal}
        userId={employeeId}
        getValues={getValues}
      />
    </BasePageLayoutWrapper>
  );
};
